import { store } from "@/store/store";
import { eventBus } from "@/eventBus";
import { mapMutations, mapActions, mapGetters } from "vuex";
import Utility from "@/mixins/Utility";

const Redirection = {
  name: "Redirection",
  data() {
    return {
      watchoToken: "", 
      isFetchingToken: false, 
    };
  },
  computed: {
    ...mapGetters(['subscriptionList'])
  },
  mounted() {
    // Fetch Watcho token on component mount if not already available
    this.ensureWatchoToken();
  },
  methods: {
    ...mapMutations(["setFirebaseUserUID", "setRegActiveDeeplink", "setContentData"]),
    ...mapActions(["listSubscription", "vzyssodeeplink"]),

    /**
     * Ensures the Watcho token is available, fetching it only if necessary
     */
    async ensureWatchoToken() {
      if (this.watchoToken || this.isFetchingToken) {
        console.log("Watcho token already available or fetching in progress:", this.watchoToken);
        return;
      }

      this.isFetchingToken = true;
      try {
        const payload = { subscriptionstatus: "ALL" };
        let plans = [...this.subscriptionList];
        console.log("fetchSubscriptions response:", plans);
        const watchoPlan = plans?.find(plan => plan.watchotoken);
        if (watchoPlan?.watchotoken) {
          console.log("Watcho token:", watchoPlan?.watchotoken);
          this.watchoToken = watchoPlan?.watchotoken;
        } else {
          console.warn("No Watcho token found in response");
        }
      } catch (error) {
        console.error("Error fetching Watcho token:", error);
      } finally {
        this.isFetchingToken = false;
      }
    },
    async redirectToLocator(content) {
      let locater = null;
      if(content?.contentprovider === "VZY") {
        let payload = {
          params: {
            assetid: content?.cpcontentid,
          }
        };
        let token =  await this.vzyssodeeplink(payload);
        if(token?.data?.deeplink_url) {
          window.open(token?.data?.deeplink_url, "_blank", "noopener,noreferrer");
          console.log("Opening deeplink URL:", token?.data?.deeplink_url);
        } else if(token?.data?.reason) {
          alert(token?.data?.reason);
          console.warn("No deeplink URL found in response");
        }
        return;
      }
      await this.ensureWatchoToken();
      locater = await this.locatorData(content);
      console.log("Locator URL:", locater);
      if (locater) {
        console.log("Opening URL:", locater);
        window.open(locater, "_blank", "noopener,noreferrer");
      } else {
        alert("Sorry, content is not accessible.");
      }
    },
    async locatorData(content) {
      const locaterData = content?.contentdetails?.filter((item) => item.devicetype === "web");
      let locater = locaterData?.[0]?.locator;
      if (!locater) return null;

      if (content?.contentprovider === "OTT_PLAY") {
        const token = localStorage.getItem("sessionToken") || "";
        const source = "KCCL";
        const backUrl = encodeURIComponent(window.location.href);
        return `https://www.ottplay.com/auth?seoUrl=${locater}&token=${token}&backUrl=${backUrl}&source=${source}`;
      } else if (content?.contentprovider === "WATCHO") {
        console.log("__watchoToken",this.watchoToken)
        const source = "kccl";
        const token = encodeURIComponent(this.watchoToken);
        return `${locater}?source=${source}&token=${token}`;
      }
      return locater;
    },
    redirectToLogin() {
      const payload = {
        state: true,
        formType: "lookup",
      };
      eventBus.$emit("authPopup", payload);
    },
    redirectToPlans() {
      this.setRegActiveDeeplink(true);
      localStorage.setItem("paymentGetwaySaveUrl", location.href);
      const currentLanguage = this.getCurrentLanguageUrlBase();
      this.$router.push({ name: "seeAllPlans", params: { lang: currentLanguage } });
    },

    redirectToDetailPage(item) {

      if(item.deeplink) {
        const parsed = new URL(item.deeplink);
        let redirectUrl = parsed.pathname.replace(/^\/+/, '');
        if(redirectUrl.includes('catchup')){
          let channelid = redirectUrl.split('/')[2];
          console.log('channelid',channelid)
           this.$router.push({
            name: 'catchup', 
            params: { id: channelid},
        });
        return;
        }
        console.log('redirectUrl', redirectUrl);
        let sectionTitle = redirectUrl.split('/')[1];
        let currentLanguage = this.getCurrentLanguageUrlBase();
        this.$router.push({
            name: 'cp-screen', 
            params: { section: sectionTitle, lang: currentLanguage },
        });
        return;
      }
      this.setContentData(item);
      console.log("redirectToDetailPage:", item);
      let category = "movies";
      if (item?.category?.toLowerCase() === "tvshow" || item?.objecttype?.toLowerCase() === "season") {
        category = "tvshows";
      } else if (item?.category?.toLowerCase() === "movie") {
        category = "movies";
      } else if (item?.category?.toLowerCase() === "tvchanel") {
        category = "livetv";
      }
      this.$router.push({
        name: "detailPageEarth",
        params: {
          category,
          title: this.cleanString(item.title),
          contentId: item.objecttype === "SEASON" ? item.seriesid : item.objectid,
        },
      });
    },
    redirectToSeeAll(screen) {
      const screenData = JSON.stringify(screen);
      localStorage.setItem("screen-list-collection", screenData);
      const currentLanguage = this.getCurrentLanguageUrlBase();
      const titleDefault = this.spacialCharEncoding(screen.title.default);
      this.$router.push({
        name: "collections",
        params: { section: titleDefault.toLowerCase(), slug: this.screenId, lang: currentLanguage },
      });
    },
    cleanString(input) {
      return input
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, "-")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");
    },
  },
  mixins: [Utility],
  watch: {
    subscriptionList(val) {
      if (val) {
        this.subscriptions = val;
      }
      this.ensureWatchoToken();
    },
  }
};
export default Redirection;
